const BaseModel = require('../BaseModel');

module.exports = class BaseEntityFilter extends BaseModel {
  static basePath = null;
  static dataType = null;

  constructor(json={}) {
    super(json);

    this.parseChildren(['entity', 'filter']);
  }
}

